export default "__VITE_ASSET__BwbXi$_k__"